import { ActivatedFacets } from "../../../components/_shared-components/generic-listing-page/types";
import { PlpRootLevelProps } from "../levels/0-root-level";

export function getActivatedFacets(subpage: PlpRootLevelProps["subpage"]): ActivatedFacets {
  return subpage.tag === "faceted-search" ? subpage.activatedFacets : {};
}
